import Grid from '@mui/material/Grid';
import { Fragment, useContext } from 'react';

import { CustomizationInfo } from './app/app-bar/CustomizationInfo';
import { OnboardingButton } from './app/pages/onboarding/OnboardingButton';
import { OnboardingContainer } from './app/pages/onboarding/OnboardingContainer';
import { CompanyLogo } from './design/components/CompanyLogo';
import { Headline, SubTitle } from './design/components/Typography';
import { ApplicationContext } from '../../shared/source/context/context';

import type { FunctionComponent } from 'react';

export const LandingPage: FunctionComponent = () => {
    const {
        actions,
        applicationState: { customization },
        translate,
    } = useContext(ApplicationContext);

    const providers = customization.isJust ? customization.value.oidcConfiguration.providers : [];

    return (
        <Fragment>
            <CustomizationInfo />
            <OnboardingContainer>
                <Grid alignItems="center" container={true} direction="column" mb={8} mt={11} rowGap={1.5}>
                    <Grid>
                        <CompanyLogo />
                    </Grid>
                    <Grid>
                        <Headline variant="h4">{translate('pages.landing-page.title')}</Headline>
                    </Grid>
                    <Grid mb={5.5}>
                        <SubTitle>{translate('pages.landing-page.subtitle')}</SubTitle>
                    </Grid>
                    {providers.map(
                        (provider, index) =>
                            !provider.hideLoginButtons && (
                                <OnboardingButton
                                    fullWidth={true}
                                    label={translate(
                                        index !== 0 ? `common.login${(index + 1).toString()}` : 'common.login',
                                    )}
                                    onClick={() => {
                                        actions.login(index);
                                    }}
                                />
                            ),
                    )}
                </Grid>
            </OnboardingContainer>
        </Fragment>
    );
};
